const config = {};

export default {
  subject: {
    presence: {
      allowEmpty: false,
      message: '^Enter ticket subject'
    }
  }
  // 'client.accountId': { // removing this for IT product
  //   presence: {
  //     allowEmpty: false,
  //     message: '^Client must be selected'
  //   }
  // }
  // 'requester.userId': {
  //   presence: {
  //     allowEmpty: false,
  //     message: '^Requester must be selected'
  //   }
  // }
};
